import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Button, Icon as IconSementic } from 'semantic-ui-react';

import { queryMockExamStudentExamCards } from 'GraphQL/query/StudentExam.query';
import ExamList from 'Components/ExamList';
import Loading from 'Components/Loading';
import { Text } from 'Components/Base';
import { FONT_SIZE, COLOR } from 'Components/Theme';

import AddStudentExam from '../AddStudentExam';

class StudentExamsList extends Component {
  render() {
    const {
      roundCode,
      locationCode,
      roundTitle,
      enabledExamCardControl,
      titleActionComponent,
    } = this.props;
    return (
      <Query query={queryMockExamStudentExamCards} variables={{ roundCode }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
          }
          if (error) return <div>{JSON.stringify(error)}</div>;
          const examCards = data ? data.mockExamStudentExamCards.studentExamCards || [] : [];
          return (
            <ExamList
              roundCode={roundCode}
              rows={examCards}
              roundTitle={roundTitle}
              enabledExamCardControl={enabledExamCardControl}
              titleActionComponent={titleActionComponent}
              addExamButton={
                <AddStudentExam
                  roundCode={roundCode}
                  locationCode={locationCode}
                  trigger={
                    <Button
                      primary
                      circular
                      compact
                      style={{ minWidth: '150px', height: '40px', display: 'inline-block' }}
                    >
                      <Text is="span" fontWeight="400" color="white" mr={8}>
                        เพิ่มวิชาสอบ
                      </Text>
                      <IconSementic name="plus" size="small" />
                    </Button>
                  }
                />
              }
            />
          );
        }}
      </Query>
    );
  }
}

export default StudentExamsList;
